import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class TicketMessaggiService {

  static getTicketMessaggiByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket-messaggi/find`;
      ApiService.postRudeRequest(resolve, reject, url, params);
    });
  };

  static createTicketMessaggio = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket-messaggi/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteTicketMessaggio = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket-messaggi/delete`;  
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateTicketMessaggio = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/ticket-messaggi/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}

